import axios from "axios"
import { handleLogoutUser } from "../screens/Logout"

export const getBaseHeaders = (extraHeaders = {}) => {
    return {
        "Client-Type": "web",
        Accept: "application/json",
        "App-Key": sessionStorage.getItem("app_key") || "master",
        "Auth-Token": localStorage.getItem("token"),
        "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
        Pragma: "no-cache",
        Expires: "0",
        "ngrok-skip-browser-warning": 123,
        "Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...extraHeaders, // 🔥 dynamic headers (polling etc)
    }
}

export const getMultipartHeaders = (extraHeaders = {}) => {
    return {
        ...getBaseHeaders(),
        "Content-Type": "multipart/form-data",
        ...extraHeaders,
    }
}

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 15000,
})

const appendParams = (url, params) => {
    if (!params) return url

    const query = new URLSearchParams(params).toString()
    return `${url}?${query}`
}

const request = async ({
    method,
    url,
    data,
    params,
    headers = {},
    isMultipart = false,
    responseType,
    skipHeaders = false,
}) => {
    try {
        const finalURL = appendParams(url, params)

        let finalHeaders = {}

        if (skipHeaders) {
            finalHeaders = headers // use only passed headers
        } else {
            finalHeaders = isMultipart ? getMultipartHeaders(headers) : getBaseHeaders(headers)
        }

        const response = await axiosInstance({
            method,
            url: finalURL,
            data,
            headers: finalHeaders,
            responseType,
        })

        return response
    } catch (error) {
        if (error?.response?.status === 401) {
            const session = sessionStorage.getItem("isLoggedIn")

            if (!session) {
                handleLogoutUser()
                throw "Session expired"
            }

            alert("You've been logged out due to Inactivity")
            handleLogoutUser()
            throw "Session expired"
        } else {
            throw error
        }
    }
}

export const FetchHelper = {
    get: (url, params, headers, responseType, skipHeaders = false) =>
        request({
            method: "GET",
            url,
            params,
            headers,
            responseType,
            skipHeaders,
        }),

    post: (url, data, params, headers) => request({ method: "POST", url, data, params, headers }),

    put: (url, data, params, headers) => request({ method: "PUT", url, data, params, headers }),

    patch: (url, data, params, headers, isMultipart = false) =>
        request({ method: "PATCH", url, data, params, headers, isMultipart }),

    delete: (url, params, headers) => request({ method: "DELETE", url, params, headers }),
    deleteWithBody: (url, data, params, headers) =>
        request({ method: "DELETE", url, data, params, headers }),

    getBlob: (url, params, headers) =>
        request({
            method: "GET",
            url,
            params,
            headers,
            responseType: "blob",
        }),

    postFormData: (url, formData, params, headers) =>
        request({
            method: "POST",
            url,
            data: formData,
            params,
            headers,
            isMultipart: true,
        }),

    putFileData: async (url, data, contentType) => {
        const res = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": contentType,
            },
            body: data,
        })

        if (!res.ok) {
            const json = await res.json()
            throw parseResponseError(json)
        }

        try {
            return await res.json()
        } catch {
            return null
        }
    },
}
